<dx-data-grid [dataSource]="people"
              [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
              [allowColumnReordering]="true"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [rowAlternationEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              (onInitialized)="onGridInitialized($event)">
    <!-- Options -->
    <dxo-data-grid-header-filter [visible]="true"> </dxo-data-grid-header-filter>
    <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
    <dxo-data-grid-group-panel [visible]="true"></dxo-data-grid-group-panel>
    <dxo-data-grid-column-chooser [enabled]="true"></dxo-data-grid-column-chooser>
    <dxo-data-grid-export [enabled]="true"
                          fileName="People"> </dxo-data-grid-export>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>

    <!-- Columns -->
    <dxi-data-grid-column caption="Id"
                          dataField="personId"
                          dataType="number"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Full Name"
                          dataField="fullName"
                          dataType="string"
                          cellTemplate="nameCellTemplate"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Active Organisations"
                          [calculateCellValue]="calculateOrganisationColumnValue"
                          cellTemplate="organisationCellTemplate"
                          dataType="string"
                          dataField="dummy_organisations"
                          [allowFiltering]="true"
                          [visible]="false"> </dxi-data-grid-column>

    @for (contactTypeMetadata of AllContactTypeMetadata; track contactTypeMetadata) {
        <dxi-data-grid-column [caption]="contactTypeMetadata.name"
                              cellTemplate="contactDetailCellTemplate"
                              [allowFiltering]="true"
                              [allowHeaderFiltering]="false"
                              [allowSorting]="false"
                              dataType="string"
                              [dataField]="contactTypeMetadata.name"
                              [visible]="contactTypeMetadata.type !== ContactType.Address && contactTypeMetadata.type !== ContactType.Messaging">
        </dxi-data-grid-column>
    }

    @if (filterForOrganisationId) {
        <dxi-data-grid-column caption="User Type"
                              [calculateCellValue]="calculateUserTypeColumnValue"
                              dataField="dummy_userType"
                              dataType="string"
                              [visible]="true"> </dxi-data-grid-column>
    }

    @if (filterForOrganisationId) {
        <dxi-data-grid-column caption="Has Platform Access"
                              [calculateCellValue]="calculateHasPlatformAccessColumnValue"
                              dataField="dummy_hasAccess"
                              dataType="boolean"
                              [visible]="true"> </dxi-data-grid-column>
    }

    @if (filterForOrganisationId) {
        <dxi-data-grid-column caption="Last Access"
                              dataField="LastAccess"
                              dataType="date"
                              [format]="DateFormats.globalize.short"> </dxi-data-grid-column>
    }

    <dxi-data-grid-column caption="Status"
                          [calculateCellValue]="calculateActiveCellValue"
                          dataType="boolean"
                          dataField="dummy_status"
                          trueText="Active"
                          falseText="Inactive"
                          [allowSorting]="true"
                          [showEditorAlways]="false"
                          [filterValue]="true"
                          [allowFiltering]="true"
                          [visible]="true"> </dxi-data-grid-column>

    @if (filterForOrganisationId) {
        <dxi-data-grid-column caption="Connection Type"
                              [calculateCellValue]="calculateConnectionTypeColumnValue"
                              dataField="dummy_connectionType"
                              dataType="string"
                              [visible]="false"> </dxi-data-grid-column>
    }

    <!-- Templates -->
    <div *dxTemplate="let item of 'nameCellTemplate'">
        <adapt-link-person [person]="item.data"></adapt-link-person>
    </div>

    <div *dxTemplate="let item of 'contactDetailCellTemplate'">
        <ul>
            @for (detail of getContactsOfTypeByName(item.data, item.column.caption); track detail) {
                <li>
                    <adapt-contact-detail [detail]="detail"></adapt-contact-detail>
                </li>
            }
        </ul>
    </div>

    <div *dxTemplate="let item of 'organisationCellTemplate'">
        <ul>
            @for (organisation of getUniqueActiveOrganisationsFromConnections(item.data.connections); track organisation) {
                <li>
                    <adapt-link-organisation [organisation]="organisation"></adapt-link-organisation>
                </li>
            }
        </ul>
    </div>
</dx-data-grid>
